import React from 'react';
import Chart from 'react-apexcharts';

function LineChart({ data, categories, graphName, yAxisLabel, xAxisLabel }) {
    // console.log("Printing props ", data, " ", categories)
    // Sample data for the chart
    // const seriesData = [
    //     {
    //         name: 'Sales',
    //         data: [65, 59, 80, 81, 56, 55, 40],
    //         // color: 'rgb(45, 55, 72)'
    //     },
    //     {
    //         name: 'Marketing',
    //         data: [30, 40, 45, 50, 48, 55, 60],
    //         // color: 'rgb(255, 99, 132)'
    //     },
    //     {
    //         name: 'Operations',
    //         data: [45, 50, 60, 55, 70, 65, 75],
    //         // color: 'rgb(54, 162, 235)'
    //     }
    // ];

    const seriesData = data ? data : []
    // Options for the chart
    const options = {
        chart: {
            type: 'line',
            zoom: {
                enabled: false
            },
            toolbar: {
                show: false
            }
        },
        xaxis: {
            // categories: ['January', 'February', 'March', 'April', 'May', 'June', 'July']
            categories: categories ? categories : [],
            labels: {
                style: {
                    padding: 10 // Set padding for x-axis labels
                },
            },
            padding: {
                left: 10,
                right: 10
            },
            title: {
                text: xAxisLabel ?  xAxisLabel : "",
                style: {
                    color: '#afafb7',
                    fontFamily: 'Arial, sans-serif'
                }
            }
        },
        toolbar: {
            show: false // Hide the toolbar
        },
        yaxis: {
            title: {
                text: yAxisLabel,
                style: {
                    color: '#afafb7',
                    fontFamily: 'Arial, sans-serif'
                }
            }
        },
        title: {
            text: graphName, // Specify the title for the whole line chart here
            align: 'center',
            style: {
                fontSize: '12px',
                color: '#afafb7'
            },
        }
    };

    return (
        <div>
            <Chart options={options} series={seriesData} type="line" height={520} />
        </div>
    );
}

export default LineChart;
